import { HelpButton } from "@certn/auth";
import { PrimaryTopNav } from "@certn/cascadia-react";

export function SimpleHeader() {
  return (
    <PrimaryTopNav testID="simple-header-nav">
      <HelpButton />
    </PrimaryTopNav>
  );
}
